export default "__VITE_ASSET__7106bfb7__"